import Vue from "vue";

export const ProblemBehaviorState = {
  problem_behavior: null,
  problem_behaviors: []
};

export const problemBehaviorGetters = {
  problemBehavior: state => {
    return state.problem_behavior;
  },
  problemBehaviors: state => {
    return state.problem_behaviors;
  }

}

export const problemBehaviorMutations = {

  setProblemBehavior: (state, data) => {
    if (data) {
      const index = state.problem_behaviors.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.problem_behaviors];
        arr[index] = data;
        Vue.set(state, "problem_behaviors", arr);
      }
    }
    Vue.set(state, "problem_behavior", data);
  },

  setProblemBehaviors: (state, data) => {
    const sortByPosition = (a, b) => {
      if (a.position < b.position) return -1;
      if (a.position > b.position) return 1;
      return 0;
    };
    data.sort(sortByPosition);
    Vue.set(state, "problem_behaviors", data);
  },

  addProblemBehavior: (state, data) => {
    Vue.set(state, "problem_behaviors", [...state.problem_behaviors, data]);
  },

  removeProblemBehavior: (state, data) => {
    const arr = state.problem_behaviors.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "problem_behaviors", arr);
  }

}

export const problemBehaviorActions = {
  async getProblemBehaviors({ commit, dispatch }, data = {}) {
    try {
      const res = await Vue.axios.secured.get("/api/v1/problem_behaviors");
      commit("setProblemBehaviors", res.data);
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to fetch problem behaviors from server.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async getProblemBehavior({ commit, dispatch }, id) {
    try {
      const res = await Vue.axios.secured.get(`/api/v1/problem_behaviors/${id}`);
      commit("setproblemBehavior", res.data);
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to fetch problem behavior from server.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async createProblemBehavior({ commit, dispatch }, data = {}) {
    try {
      const res = await Vue.axios.secured.post("/api/v1/problem_behaviors", { problem_behavior: data.problemBehavior });
      commit("addProblemBehavior", res.data);
      const message = `Problem behavior has been successfully added.`;
      dispatch("showToast", { message, type: "success" });
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to create problem behavior.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async updateProblemBehavior({ commit, dispatch }, data) {
    const {problemBehavior} = data
    try {
      const res = await Vue.axios.secured.patch(`/api/v1/problem_behaviors/${problemBehavior.id}`, { problem_behavior: problemBehavior });
      commit("setProblemBehavior", res.data);
      const message = `Problem behavior ${res.data.code_definition} has been successfully updated.`;
      dispatch("showToast", { message, type: "success" });
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to update problem behavior.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async deleteProblemBehavior({ commit, dispatch }, data = {}) {
    const {problemBehavior} = data
    try {
      await Vue.axios.secured.delete(`/api/v1/problem_behaviors/${problemBehavior.id}`);
      commit("removeProblemBehavior", { id: problemBehavior.id });
      const message = `Problem behavior ${problemBehavior.code_definition} has been successfully removed.`;
      dispatch("showToast", { message, type: "success" });
      return { success: true };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to delete problem behavior.";
      dispatch("showToast", { message, type: "error" });
      return { success: false };
    }
  },

  moveProblemBehavior: async ({ dispatch }, { problemBehavior }) => {
    try {
      await Vue.axios.secured.patch(`/api/v1/problem_behaviors/${problemBehavior.id}`, { problem_behavior: problemBehavior });
      dispatch("getProblemBehaviors");
      const message = `Problem behavior ${problemBehavior.code} has been successfully updated.`;
      dispatch("showToast", { message, type: "success" });
    } catch (error) {
      const message = (error.response && error.response.data) || "Unable to update problem behavior.";
      dispatch("showToast", { message, type: "error" });
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/problem-behavior.js